import React from 'react'
import { Router } from '@reach/router'
import Layout from '../components/Layout'
import Convenios from '../components/Agendamento/Convenios'
import Calendario from '../components/Agendamento/Calendario'
import Horarios from '../components/Agendamento/Horarios'
import Detalhes from '../components/Agendamento/Detalhes'
import Sucesso from '../components/Agendamento/Sucesso'
import Login from '../components/Agendamento/Login'
import PrivateRoute from '../components/Agendamento/PrivateRoute'

const Agendamento = ({ location }) => {
  return (
    <Layout title="Agendamento de visitas" description="">
      <Router basepath="/agendamento-de-visitas" location={location}>
        <PrivateRoute path="/convenios" component={Convenios} />
        <PrivateRoute path="/calendario" component={Calendario} />
        <PrivateRoute path="/horarios" component={Horarios} />
        <PrivateRoute path="/detalhes" component={Detalhes} />
        <PrivateRoute path="/sucesso" component={Sucesso} />
        <Login path="/" />
      </Router>
    </Layout>
  )
}

export default Agendamento
